import React from 'react';
import {Trans} from 'react-i18next';
import {connect} from 'react-redux';
import DefaultLayout from '../../../components/layout/DefaultLayout';
import AsyncPartnerHome from './async';

const Title = ({account: {firstName}}) => (
  <Trans i18nKey="p.p.home.title">
    Welcome to YouCam Partner Program, {{firstName}}
  </Trans>
);

const TitleWrapper = connect(
  state => ({account: state.components.auth.accountSummary.account}),
  null
)(Title);

export default [
  <DefaultLayout
    exact
    key="partner-home"
    path="/partner"
    component={AsyncPartnerHome}
    title={<TitleWrapper />}
    subtitle={<Trans i18nKey="p.p.home.subtitle">Home Page</Trans>}
  />,
];
